import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '@root/firebase'; // Firebase initialization

const logEvent = async (eventType, details = {}) => {
  try {
    await addDoc(collection(db, 'user_logs'), {
      eventType,
      details,
      timestamp: serverTimestamp(),
    });
  } catch (error) {
    console.error('Error logging event: ', error);
  }
};

export default logEvent;
